'use client'

import { useTranslations } from 'next-intl'

import { ActionButton, DropdownMenu, Icon } from '@graftcode/design-system'

import { LAYOUT_TEST_IDS } from '@common/common-test-ids.const'

import { PORTAL_ONBOARDING_DOM_TARGET, PortalOnboardingTarget } from '@apps/portal-onboarding'
import { useLayoutStore } from '@stores/layout/layout.store'

import { ADD_NEW_ITEMS } from './layout.const'

type SidebarAddNewProps = {
  onItemClick: (item: string) => void
}

export function SidebarAddNew({ onItemClick }: SidebarAddNewProps) {
  const t = useTranslations('core')
  const { sidebarCollapsed } = useLayoutStore()

  return (
    <PortalOnboardingTarget id={PORTAL_ONBOARDING_DOM_TARGET.addNew} data-testid={LAYOUT_TEST_IDS.sidebarAddNew}>
      <DropdownMenu width="m" items={ADD_NEW_ITEMS} onItemClick={onItemClick}>
        <ActionButton
          size="l"
          fullWidth
          text={sidebarCollapsed ? '' : t('sidebar.addNew')}
          icon={Icon.AddFilled}
          iconOnly={sidebarCollapsed}
          keyboardShortcut="⌘N"
        />
      </DropdownMenu>
    </PortalOnboardingTarget>
  )
}
